import { Component, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, SideNav, TopBar } from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import { postData, postFile, updateData} from './constants.js';
const moment = require('moment');

function AccRequestList(props) {
    const change_request_list = props.data.map((item)=>
      <tr key={item.id} id={item.id}>
          <td>{moment(item.application_date).format("l")}</td>
          <td>{item.change_state}</td>
          <td>{item.applicant_name}</td>
          <td className="text-nowrap">{(item.status==="approved")?"Approved":(item.status==="declined")?"Declined":"Pending"}</td>
          <td className="text-nowrap">{item.chairpersonACC}</td>
          <td className="text-nowrap">{item.approved_date?moment(item.approved_date).format("l"):''}</td>
          <td><Link id={item.id} className="font-weight-bold " to={'/acc-request/'+item.id}>View details</Link></td>
      </tr>
    );
    return(
        <>
        <div className="row">
            <div className="col-xs-12 col-md-12">

                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <h4 className="m-0 font-weight-bold text-white">ACC Requests</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive change_request-table">
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Request Type</th>
                                        <th>Request By</th>
                                        <th>Status</th>
                                        <th>Chairperson</th>
                                        <th>Approved</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                      {change_request_list}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

class AccRequests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true
    };
  }

  async getChangeRequests() {
    try {
      const response = await fetch('/api/change-requests');
      const json = await response.json();
      console.log(json);
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getChangeRequests();
  }

  render() {
    return (
      <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <AccRequestList data={this.state.data} />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
      </>
    );
  }
}

class AccRequestResponseForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        acc_request_id :this.props.accRequestId,
        response_text  :"",
        filename       :null,
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
      const target = event.target;
      const value =  target.value;
      const name = target.name;
      this.setState({
        [name]: value
      });
    }

    handleSubmit(event) {
      event.preventDefault();
      var CRform = document.getElementById("acc-request-response-form");
      CRform.disabled=true;
      var formData = new FormData();
      var file = document.getElementById("inputGroupFile05").files[0];
      if(file){
        this.setState({"filename": file.name});
        formData.append('File', file);
      }
      var data = this.state;
      formData.append('jsonData', JSON.stringify(data));

      postFile('/api/acc_request_response', formData)
        .then((response) => {
          console.log(response);
          CRform.disabled=false;
          this.setState({"filename": null, 'response_text': ''});
          document.getElementById("response-form").reset();
          this.props.getAccRequestDetails();
      });
    }

    render() {
      return(
          <form className="user mt-2" id="response-form" onSubmit={this.handleSubmit} autoComplete="off">
            <fieldset id="acc-request-response-form">
              <small className="fw-bold">Comment </small>
              <div className="row">
                  <div className="col-lg-12 col-xs-12">
                      <div className="input-group">
                        <input type="text" name="response_text" maxLength="250" value={this.state.response_text} onChange={this.handleInputChange} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" required />
                        <div className="input-group-append">
                          <label for="inputGroupFile05" className="btn btn-outline-secondary mb-0 input-group-button"><i className="fas fa-file action-buttons"></i></label>
                          <input id="inputGroupFile05" type="file" className="response-file-input" onChange={this.handleSubmit} />
                          <button type="submit" className="btn btn-outline-primary input-group-button"><i className="fas fa-comment-alt action-buttons"></i></button>
                        </div>
                      </div>
                  </div>
              </div>
            </fieldset>
          </form>
      );
    }
}

class AccRequestDetails extends Component {
  constructor(props){
    super(props);
    this.state = {
      id             : this.props.data.id,
      chairpersonACC : this.props.data.chairpersonACC,
      status         : this.props.data.status
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = this.state;
    this.setState({ show: false, isLoading: true });
    updateData('/api/acc-request/'+data.id, data)
      .then((response) => {
        console.log(response);
        this.props.navigate("/acc-requests");
    });
  }

  render() {
    var data = this.props.data;
    const acc_request_responses = this.props.responses.map((item,index)=>{
      return(
        <div key={item.id} className="row no-gutters my-1">
          <div className={item.commented_resident?"col-12 d-flex justify-content-end":"col-12 text-dark"}>
            {item.response_text && item.response_text}
            {item.file_url && <embed src={item.file_url} width="300" height="300" />  }
          </div>
          <div className={item.commented_resident?"col-12 d-flex justify-content-end":"col-12"}>
            <small className="mx-2">{item.commented_user},</small>
            <small className="m-0">{moment(item.created_date).format("lll")}</small>
          </div>
        </div>
      );
    });

    return (
      <>
        <div className="row">
            <div className="col-xs-12 col-md-6 col-lg-7">
              <div className="card shadow-sm mb-4">
                <div className="card-header py-3 d-flex align-items-center">
                    <h4 className="m-0 font-weight-bold text-light">ACC Request details</h4>
                </div>
                <div className="card-body acc-approval-form">
                  <div className="row">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Date of Application </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.application_date).format("LLL")} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Application Status </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.status} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Name of the Owner </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.applicant_name} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Address </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.applicant_address} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Contact Email </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.email} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Contact Phone </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.phone} </div>
                  </div>
                  {(data.status==="Approved") &&
                    (
                      <>
                        <div className="row my-3">
                          <div className="col-xs-6 col-md-4 font-weight-bold">Approved Date </div>
                          <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.approved_date).format("LLL")} </div>
                        </div>
                        <div className="row my-3">
                          <div className="col-xs-6 col-md-4 font-weight-bold">Chairperson ACC </div>
                          <div className="col-xs-6 col-md-8 font-weight-bold"> {data.chairpersonACC} </div>
                        </div>
                      </>
                    )
                  }
                  {(data.status==="declined") &&
                    (
                      <>
                        <div className="row my-3">
                          <div className="col-xs-6 col-md-4 font-weight-bold">Not Approved Date </div>
                          <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.declined_date).format("LLL")} </div>
                        </div>
                        <div className="row my-3">
                          <div className="col-xs-6 col-md-4 font-weight-bold">Chairperson ACC </div>
                          <div className="col-xs-6 col-md-8 font-weight-bold"> {data.chairpersonACC} </div>
                        </div>
                      </>
                    )
                  }
                  {data.change_state==="Architecture"?(
                    <>
                      {
                        data.roof_replacement &&
                         (
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Roof Replacement </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.roof_replacement} </div>
                            </div>
                          )
                        }
                      {
                        data.repainting &&
                        (
                          <>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Repainting </div>
                              <div className="col-xs-6 col-md-8 font-weight-bold"> {data.repainting} </div>
                            </div>
                            <div className="row my-3">
                              <div className="col-xs-6 col-md-4 font-weight-bold">Repainting attach color sample </div>
                              <div className="col-xs-6 col-md-8">
                                <a href={data.repainting_color_ref} className="hyperlink font-weight-bold" target="_blank">View attachment</a>
                              </div>
                            </div>
                          </>
                        )
                      }
                      {
                        data.patio &&
                        (
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Patio </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.patio} </div>
                          </div>
                        )
                      }
                      {
                        data.garage_door &&
                        (
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Garage Door </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.garage_door} </div>
                          </div>
                        )
                      }
                      {
                        data.cart_room_door &&
                        (
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Cart Room Door </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.cart_room_door} </div>
                          </div>
                        )
                      }
                      <div className="row my-3">
                        <div className="col-xs-6 col-md-4 font-weight-bold">Others </div>
                        <div className="col-xs-6 col-md-8 font-weight-bold"> {data.others} </div>
                      </div>
                    </>
                  ):(
                    <>
                      {data.change_state==="New Construction"?(
                        <>
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Construction Incharge / Handled By </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_type} </div>
                          </div>
                          {(data.contractor_type==="contractor") &&
                            <>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">General Contractor. Name </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_name} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">General Contractor. Address </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_address} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">General Contractor. Lisence </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_lisence} </div>
                              </div>
                            </>
                          }
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Proposed start-up date </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.start_date).format("LL")} </div>
                          </div>
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Proposed completion date </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.completion_date).format("LL")} </div>
                          </div>
                          {data.hcbp_ref &&
                            <div className="row my-3">
                              <h5 className="col-xs-12 col-md-12 font-weight-bold">Copy of a Hernando County Building Permit Application Attachment:</h5>
                              <a href={data.hcbp_ref} className="hyperlink font-weight-bold" target="_blank">View attachment</a>
                            </div>
                          }
                        </>
                      ):(
                        <>
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Reason for Request </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.reason} </div>
                          </div>
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Name of the Lisenced Contractor </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_name} </div>
                          </div>
                          <div className="row my-3">
                            <div className="col-xs-6 col-md-4 font-weight-bold">Contractor Lisence </div>
                            <div className="col-xs-6 col-md-8 font-weight-bold"> {data.contractor_lisence} </div>
                          </div>
                          {data.tree1_type &&
                            <>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 1 Type </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree1_type} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 1 Diameter </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree1_diameter} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 1 Circumference </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree1_circumference} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 1 Location </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree1_location} </div>
                              </div>
                            </>
                          }
                          {data.tree2_type &&
                            <>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 2 Type </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree2_type} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 2 Diameter </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree2_diameter} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 2 Circumference </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree2_circumference} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 2 Location </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree2_location} </div>
                              </div>
                            </>
                          }
                          {data.tree3_type &&
                            <>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 3 Type </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree3_type} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 3 Diameter </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree3_diameter} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 3 Circumference </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree3_circumference} </div>
                              </div>
                              <div className="row my-3">
                                <div className="col-xs-6 col-md-4 font-weight-bold">Tree 3 Location </div>
                                <div className="col-xs-6 col-md-8 font-weight-bold"> {data.tree3_location} </div>
                              </div>
                            </>
                          }
                        </>
                      )}
                    </>
                  )}
                  <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
                      <div className="row form-group">
                          <div className="col-xs-6 col-md-4 font-weight-bold"><label>Chairperson ACC</label></div>
                          <div className="col-xs-6 col-md-8">
                            <input type="text" name="chairpersonACC" className="form-control" value={this.state.chairpersonACC} onChange={this.handleInputChange} required />
                          </div>
                      </div>
                      <div className="row form-group">
                          <div className="col-xs-6 col-md-4 font-weight-bold"><label>Update Application Status</label></div>
                          <div className="col-xs-6 col-md-8">
                            <select name="status" className="form-select" value={this.state.status} onChange={this.handleInputChange}>
                              <option value="approved">Approved</option>
                              <option value="declined">Declined</option>
                              <option value="pending">Pending</option>
                            </select>
                          </div>
                      </div>
                      <div className="form-group">
                        <input type="submit" className="btn btn-bg-success mr-3" value="Submit" />
                        <Link to="/acc-requests" className="btn btn-danger">Cancel</Link>
                      </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-md-6 col-lg-5">
              <div className="card shadow mb-2">
                <div className="card-header">
                    <h4 className="m-0 font-weight-bold text-light">Responses</h4>
                </div>
                <div className="card-body">
                  <div className="acc-request-response-view">
                    {acc_request_responses}
                  </div>
                  <AccRequestResponseForm accRequestId={data.id} getAccRequestDetails={this.props.getAccRequestDetails} />
                </div>
              </div>
            </div>
        </div>
      </>
    );
  }
}

function ViewAccRequest() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [accRequestData, setAccRequestData] = useState({});
  const [responses, setResponses] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const getAccRequestDetails = async() => {
    try {
      const response = await fetch('/api/change-request/'+id);
      const json = await response.json();
      setAccRequestData(json.acc_request);
      setResponses(json.acc_request_responses);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    getAccRequestDetails();
  }, []);

  return(
    <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                    {!isLoading?
                      <AccRequestDetails data={accRequestData} responses={responses} getAccRequestDetails={getAccRequestDetails} navigate={navigate} />
                    :
                      <> </>
                    }
                  </div>
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
    </>
  );
}

export { AccRequests, ViewAccRequest };
